import { defineComponent } from 'vue'
import TemplateDefault from '@/components/_core/TemplateDefault.vue'
import FormDefault from '@/components/form/FormDefault.vue'
import ModalDefault from '@/components/modal/ModalDefault.vue'
import ValidationProvider from '@/components/validation/ValidationProvider.vue'
import FieldErrorMessage from '@/components/error/FieldErrorMessage.vue'

/**
 * グローバルコンポーネント登録
 * 利用するページが多いコンポーンネントをここで登録する
 *
 * (ページ固有のコンポーネントは各ページでコンポーネントを import する)
 */
const globalComponents: Array<ReturnType<typeof defineComponent>> = [
  // Templates
  TemplateDefault,

  // Form
  FormDefault,

  // Modal
  ModalDefault,

  // Validation
  ValidationProvider,

  // Error
  FieldErrorMessage,
]

export default globalComponents
